import HCLTreeVertexValue, {HCLTreeVertexValueJSON} from "../../../HCLTreeVertexValue/HCLTreeVertexValue";
import Label from "../../../HCLTreeVertexValue/Label";
import Outcome, {OutcomeJSON} from "../../../HCLTreeVertexValue/Outcome";

interface FunctionalEventPortValueJSON extends HCLTreeVertexValueJSON {
  outcome: OutcomeJSON;
}

class FunctionalEventPortValue extends HCLTreeVertexValue {

  private outcome: Outcome;

  constructor(label?: Label, outcome?: Outcome) {
    super(label || new Label());
    this.outcome = outcome;
  }

  /**
   * @return {Outcome}
   */
  getOutcome(): Outcome {
    return this.outcome;
  }

  /**
   * @param {Outcome} outcome
   */
  setOutcome(outcome: Outcome): void {
    this.outcome = outcome;
  }

  toJSON(): FunctionalEventPortValueJSON | HCLTreeVertexValueJSON {
    if (this.outcome) {
      return ({
        ...super.toJSON(),
        outcome: this.outcome.toJSON()
      });
    }

    return ({
      ...super.toJSON()
    });
  }

  clone(): HCLTreeVertexValue {
    throw new Error('Unable to clone')
  }

}

export default FunctionalEventPortValue;
